import env from "../env"
import { dom } from './utils-js'
// import utils from "./index";
// import hk from "../components/conf/hotKey";
import api from "../api";

// TODO: 实现用户登陆之后将 nobody 替换为用户 ID
let basePath = "/user/nobody/conf"
let fileName = "default.conf"
let fullPath = `${basePath}/${fileName}`

let DefaultConfDefinition = {
  autoStart: false,
  autoOpenWinOnStart: true,
  closeWindowWithoutConfirm: false,
  
  termEnableLink: false,
  termAutoCopySelected: true,
  termEnableGPUAccelerate: true,
  // hotKeyDef: new utils.hotKey.HotKeyDefinition(hk.defaultHotKeyGroups, "Default HotKeys"),
}

let GlobalConf = DefaultConfDefinition

function save(conf, cb) {
  GlobalConf = conf
  console.log("saved GlobalConf:", GlobalConf)
  let blob = new Blob([JSON.stringify(conf)])
  api.hifs.postFile(fullPath, blob, cb)
  takeEffect(conf)
}

// load configuration from server, cb is callback(error, conf, response)
function load(cb) {
  api.hifs.getFile(fullPath, (error, data, response) => {
    if (error) {
      cb(error, data, response)
      return
    }
    cb(error, JSON.parse(data), response)
  })
}

function takeEffect(conf) {
  console.log("conf takeEffect:", conf)

  // console.log(`conf takeEffect: conf.closeWindowWithoutConfirm: ${conf.closeWindowWithoutConfirm}`)
  conf.closeWindowWithoutConfirm ? dom.disableCloseConfirm() : dom.enableCloseConfirm()
  if (env.isElectron) {
    const { ipcRenderer } = window.require("electron")
    // console.log(`conf takeEffect: setup electron confSetWinCloseConfirm: ${conf.closeWindowWithoutConfirm}`)
    ipcRenderer.send("confSetWinCloseConfirm", conf.closeWindowWithoutConfirm)
    ipcRenderer.send("confAutoStart", conf.autoStart)
    ipcRenderer.send("confAutoOpenWinOnStart", conf.autoOpenWinOnStart)
  }
}

function reset(cb) {
  let blob = new Blob([JSON.stringify(DefaultConfDefinition)])
  api.hifs.postFile(fullPath, blob, cb)
}

if (env.isElectron) {
  const { ipcRenderer } = window.require("electron")
  ipcRenderer.on('closeWindowWithoutConfirm', (event, noConfirm) => {
    console.log("closeWindowWithoutConfirm: status:", noConfirm)
    GlobalConf.closeWindowWithoutConfirm = noConfirm
    save(GlobalConf)
  })

  ipcRenderer.on('confUpdateAutoStart', (event, data) => {
    console.log("confUpdateAutoStart: data:", data)
    GlobalConf.autoStart = data
    save(GlobalConf)
  })
  ipcRenderer.on('confAutoOpenWinOnStart', (event, data) => {
    console.log("confAutoOpenWinOnStart: data:", data)
    GlobalConf.autoOpenWinOnStart = data
    save(GlobalConf)
  })
}


let shellList = []
api.shell.getShellList((error, data, response) => {
  if (error) {
    self.api.errHandler(self, error, response)
    return
  }
  
  console.log("conf.js data:", data)
  shellList = data
  console.log("conf.js shellList:", shellList)
})

function loadLocalSessDefault() {
  let sess = localStorage.getItem("default-session")
  if (sess !== null) {
    return sess
  }

  return shellList[0]
}

function saveLocalSessDefault(sess) {
  localStorage.setItem("default-session", sess)
}

export default {
  basePath,
  fileName,
  fullPath,

  save,
  load,
  reset,
  takeEffect,

  GlobalConf,
  DefaultConfDefinition,

  shellList,
  loadLocalSessDefault,
  saveLocalSessDefault,
}
